<nav
  aria-label="Navegação principal"
  class="sticky top-16 z-30 shrink-0 bg-rfy-surface [border-bottom:1px_solid_var(--rfy-border)]"
>
  <div class="flex h-[3.25rem] items-stretch gap-1 px-[clamp(0.75rem,2vw,1.5rem)]">
    @for (item of navegacao.menu(); track item.rotulo) {
      @if (item.submenu; as submenu) {
        <!-- Grupo: dropdown do design system -->
        <div [class]="grupoAtivo(item) ? CLASSES_GRUPO_ATIVO : CLASSES_GRUPO">
          <app-menu
            [rotulo]="item.rotulo"
            posicao="baixo-inicio"
            largura="larga"
            [aberto]="grupoAberto() === item.rotulo"
            (abertoChange)="definirAberto(item.rotulo, $event)"
          >
            <button
              appMenuGatilho
              type="button"
              [class]="grupoAberto() === item.rotulo ? CLASSES_GATILHO_ABERTO : CLASSES_GATILHO"
            >
              <app-icon [nome]="item.icone" tamanho="md" class="text-rfy-primary" />
              {{ item.rotulo }}
              <app-icon
                [nome]="grupoAberto() === item.rotulo ? 'chevron-cima' : 'chevron-baixo'"
                tamanho="xs"
                [class.text-rfy-primary]="grupoAberto() === item.rotulo"
              />
            </button>

            @for (sub of submenu; track sub.rota) {
              <a
                app-menu-item
                iconeCaixa
                [icone]="sub.icone"
                [routerLink]="sub.rota"
                [attr.aria-current]="navegacao.rotaAtiva() === sub.rota ? 'page' : null"
              >
                {{ sub.rotulo }}
              </a>
            }
          </app-menu>
        </div>
      } @else {
        <!-- Item simples: link direto para a rota -->
        <a
          [routerLink]="item.rota"
          [class]="navegacao.rotaAtiva() === item.rota ? CLASSES_ITEM_ATIVO : CLASSES_ITEM"
          [attr.aria-current]="navegacao.rotaAtiva() === item.rota ? 'page' : null"
        >
          <app-icon [nome]="item.icone" tamanho="md" class="text-rfy-primary" />
          {{ item.rotulo }}
        </a>
      }
    }
  </div>
</nav>
